import { IAggregation, IAggregationType, ISourceSchema } from "@types";
import { hasValue } from "uxp/components";

export interface IAggregatePanelProps {
    aggregation: IAggregation,
    onChange: (updated: IAggregation) => void,
    fields: ISourceSchema
}

export function getDefaultAggregation(): IAggregation {
    return {
        fields: [],
        aggregates: [
            {
                field: '',
                type: IAggregationType.Count,
                name: null
            }
        ]
    };
}

export function getInitialAggregation(aggregation?: IAggregation): IAggregation {

    const aggregates = aggregation?.aggregates || []
    if (aggregates.length == 0) aggregates.push({
        field: '',
        type: IAggregationType.Count,
        name: null
    })

    return {
        fields: aggregation?.fields || [],
        aggregates: aggregates
    };
}

export function validateAggregation(aggregation: IAggregation): { isValid: boolean, error?: string, uniqueFields?: string[] } {

    if (!aggregation) return { isValid: false, error: 'Aggregation is required' }

    if (!aggregation.aggregates || aggregation.aggregates.length === 0) return { isValid: false, error: 'At least one aggregate is required' }
    else {
        const allConfigured = aggregation.aggregates.every((aggregate) => {
            return hasValue(aggregate.field) && hasValue(aggregate.type);
        })

        if (!allConfigured) return { isValid: false, error: "All conditions need to be configured properly" }
    }

    const allFields = new Set<string>();

    // Add fields from aggregation.fields
    if (aggregation.fields) aggregation.fields.forEach(field => allFields.add(field));
    // Add fields from aggregation.aggregates
    if (aggregation.aggregates) {
        aggregation.aggregates.forEach(aggregate => {
            if (aggregate.field) {
                allFields.add(aggregate.field);
            }
        });
    }

    return { isValid: true, uniqueFields: Array.from(allFields) }
}